import React from 'react';
import { Link } from 'react-router-dom';
import { Users, HeartHandshake, Heart, Calendar, Share2 } from 'lucide-react';

const AdminDashboard = () => {
  const sections = [
    { icon: Users, title: 'Volunteers', link: '/admin/volunteers' },
    { icon: HeartHandshake, title: 'Help Requests', link: '/admin/help-requests' },
    { icon: Heart, title: 'Donations', link: '/admin/donations' },
    { icon: Calendar, title: 'Events', link: '/admin/events' },
    { icon: Share2, title: 'Social', link: '/admin/social' }
  ];

  return (
    <div className="section-padding">
      <div className="container-custom">
        <h1 className="text-4xl font-bold mb-8">Admin Dashboard</h1>
        <div className="grid md:grid-cols-3 gap-6">
          {sections.map((s, i) => (
            <Link key={i} to={s.link} className="card p-6 hover:shadow-xl">
              <s.icon className="w-12 h-12 text-primary mb-4" />
              <h3 className="text-xl font-bold">{s.title}</h3>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};
export default AdminDashboard;
